import { render, staticRenderFns } from "./DefaultTableHeaders.vue?vue&type=template&id=4827dbe4"
import script from "./DefaultTableHeaders.vue?vue&type=script&lang=js"
export * from "./DefaultTableHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports